import { READ_STATUS_CHANGE } from '../actions/readStatusChange';

export default (previousState = 'NEW', { type, payload }) => {
  if (type === READ_STATUS_CHANGE) {
    return payload.readStatus;
  }
  return previousState;
};
